const routes = [
  {
    name: 'platform-admin',
    path: '/platform-admin',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'platform-admin',
      allowedRoles: ['app-administrator', 'client-administrator', 'system-administrator'],
      breadcrumb: {
        label: 'platform-admin.breadcrumbs.platform-admin',
        route: 'platform-admin-home',
      },
    },
    children: [
      {
        name: 'platform-admin-home',
        path: '',
        component: () =>
          import(
            '@/modules/platform-admin/containers/platform-admin.container.vue'
          ),
      },
      {
        name: 'new-client',
        path: 'new-client',
        meta: {
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.new-client',
            route: 'new-client',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/platform-admin-form-client.container.vue'
          ),
      },
      {
        path: 'system-permissions',
        name: 'system-permissions',
        meta: {
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.system-permissions',
            route: 'system-permissions',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/system-settings.container.vue'
          ),
      },
      {
        path: 'system-administrator',
        name: 'system-administrator',
        meta: {
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.system-administrator',
            route: 'system-administrator',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/system-administrator.container.vue'
          ),
      },
      {
        path: 'digital-leaders',
        name: 'digital-leaders',
        meta: {
          allowedRoles: ['app-administrator', 'system-administrator'],
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.digital-leaders',
            route: 'digital-leaders',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/digital-leaders.container.vue'
          ),
      },
      {
        path: 'bradley-access',
        name: 'bradley-access',
        meta: {
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.bradley-access',
            route: 'pbradley-access',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/bradley-access.container.vue'
          ),
      },
      {
        path: 'industry-configuration',
        name: 'industry-configuration',
        meta: {
          allowedRoles: ['app-administrator', 'system-administrator'],
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.industry-configuration',
            route: 'industry-configuration',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/industry-configuration.container.vue'
          ),
      },
      {
        path: 'new-project-requests',
        name: 'new-project-requests',
        meta: {
          allowedRoles: ['app-administrator', 'system-administrator'],
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.new-project-requests',
            route: 'new-project-requests',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/project-requests.container.vue'
          ),
      },
      {
        path: 'analytics-sync-schedules',
        name: 'analytics-sync-schedules',
        meta: {
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.analytics-sync-schedules',
            route: 'analytics-sync-schedules',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/analytics-sync-schedules.container.vue'
          ),
      },
      {
        path: 'analytics-sync-schedules/new',
        name: 'analytics-sync-schedules-new',
        meta: {
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.analytics-sync-schedules-new',
            route: 'analytics-sync-schedules-new',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/analytics-sync-schedules-new.container.vue'
          ),
      },
      {
        path: 'analytics-sync-schedules/:id/edit',
        name: 'analytics-sync-schedules-edit',
        meta: {
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.analytics-sync-schedules-edit',
            route: 'analytics-sync-schedules-edit',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/analytics-sync-schedules-new.container.vue'
          ),
      },
      {
        path: 'releases',
        name: 'platform-admin-releases',
        meta: {
          breadcrumb: {
            label: 'platform-admin.breadcrumbs.releases',
            route: 'platform-admin-releases',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/platform-admin-releases.container.vue'
          ),
      },
      {
        path: 'translation-coverage',
        name: 'translation-coverage',
        meta: {
          allowedRoles: ['app-administrator', 'system-administrator'],
          breadcrumb: {
            label: 'platform-admin.translation-coverage.breadcrumb',
            route: 'translation-coverage',
          },
        },
        component: () =>
          import(
            '@/modules/platform-admin/containers/translation-coverage.container.vue'
          ),
      },
    ],
  },
]

export default routes
